export enum AssetType {
  IMAGE = 'image',
}
